import React, { useEffect, useState, useRef } from 'react'
import { get_fund_invoices, delete_sanction_order } from '../../helper/Api';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import InvoiceOverlay from "../Disbursment/Components/InvoiceOverlay";
import moment from "moment";
import Spinner from '../Tools/spinner';
import { useNavigate } from 'react-router-dom';

const InvoiceList = ({setSelectednvoice, selectedInvoice, fromDate, toDate, dateColumn, searchStr, approval, all}) => {
    const [loading, setLoading] = useState(false);
    const {authData}=useSelector((state)=>state.authData);
    const [data, setData]=useState([]);
    const dataRef = useRef([]);
    const [overlay, setOverlay] = useState(true);
    const [activeKeys, setActiveKeys] = useState([]);
    const navigate = useNavigate();

    const handleInvoiceAccordian = (key) => {
        setActiveKeys(
            (prevKeys) =>
            prevKeys.includes(key)
                ? prevKeys.filter((k) => k !== key)
                : [...prevKeys, key]
        );
    }
    const invoiceDetailsRef = useRef(null);

    const showInvoiceDetails = (invoiceDetails) => {
        invoiceDetailsRef.current = invoiceDetails;
        setOverlay(false);
    }

    const showDeleteButton = (user_type, l2_status, l3_status) => {
        if (user_type == 'l1') {
            if ((l2_status == 2 || l3_status == 2)) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    const deleteInvoice = async (invoiceId) => {
        try {
            const isDeleted = await delete_sanction_order(invoiceId);
            if(isDeleted.data.status){
                await fetchInvoices();
                toast.success(isDeleted.data.message, {
                    position: toast.POSITION.TOP_CENTER
                });
            }else{
                toast.error(isDeleted.data.message, {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        }catch (e) {
            console.log('eee', e);
            toast.error('Something went wrong.', {
                position: toast.POSITION.TOP_CENTER
            });
        }
        
    }

    function structureData(data) {
        const sanctionMap = new Map();

        data.forEach(item => {
            const sanctionId = item.sanction_order_id;
            const voucherId = item.voucher_id;
            const invoiceAmount = parseFloat(item.invoice_value || 0);

            // Create sanction order if not exists
            if (!sanctionMap.has(sanctionId)) {
            sanctionMap.set(sanctionId, {
                sanction_order_id: sanctionId,
                sanction_order_no: item.sanction_order_no,
                sanction_order_date: item.sanction_order_date,
                sanction_order_url: item.sanction_order,
                vouchers: new Map(),
                sanction_amount: 0
            });
            }

            const sanction = sanctionMap.get(sanctionId);

            // Create voucher if not exists
            if (!sanction.vouchers.has(voucherId)) {
            sanction.vouchers.set(voucherId, {
                voucher_id: voucherId,
                voucher_no: item.voucher_no,
                voucher_date: item.voucher_date,
                voucher_url: item.voucher,
                invoices: [],
                voucher_amount: 0
            });
            }

            const invoice = { ...item };

            // Push invoice and add to amounts
            const voucher = sanction.vouchers.get(voucherId);
            voucher.invoices.push(invoice);
            voucher.voucher_amount += invoiceAmount;
            sanction.sanction_amount += invoiceAmount;
        });

        // Convert nested maps to arrays
        const result = [];
        sanctionMap.forEach(sanction => {
            sanction.vouchers = Array.from(sanction.vouchers.values());
            result.push(sanction);
        });

        return result;
    }
    
    const fetchInvoices=async()=>{
      try {
        setLoading(true);
        const invoices_response=await get_fund_invoices({
            user_type: authData?.user?.user_type?.toUpperCase() || 'L1', 
            from_date: fromDate || '',
            to_date: toDate || '', 
            dateColumn: dateColumn || '',
            search_str: searchStr || '',
            isAll: all,
        });

        if(invoices_response.data.status){
          dataRef.current = invoices_response.data.list;
          setData(structureData(invoices_response.data.list));
          setLoading(false);
        }
      } catch (error) {
        console.log('ee', error)
        setLoading(false);
        toast.success('Something went wrong.', { position: toast.POSITION.TOP_CENTER, });
      }
    }
    useEffect(() => {
        fetchInvoices();
    }, [fromDate, toDate, searchStr, dateColumn, all])

    const handleInvoiceSelect = (key, id, isChecked) => {
        if(isChecked) {
            if(key === 'sanctionOrder') {
                let invoices = dataRef.current.filter(e => Number(e.sanction_order_id) === Number(id) && e.approval_status !== "2" && e.l3_approval_status !== "2");
                setSelectednvoice((prev) => [...prev, ...invoices])
            }
            if(key === 'voucher') {
                let invoices = dataRef.current.filter(e => Number(e.voucher_id) === Number(id) && e.approval_status !== "2" && e.l3_approval_status !== "2");
                setSelectednvoice((prev) => [...prev, ...invoices])
            }
            if(key === 'invoice') {
                let invoices = dataRef.current.filter(e => Number(e.id) === Number(id) && e.approval_status !== "2" && e.l3_approval_status !== "2");
                setSelectednvoice((prev) => [...prev, ...invoices])
            }
        } else {
            if(key === 'sanctionOrder') {
                setSelectednvoice(prev => prev.filter(item => Number(item.sanction_order_id) !== Number(id)));
            }
            if(key === 'voucher') {
                setSelectednvoice(prev => prev.filter(item => Number(item.voucher_id) !== Number(id)));
            }
            if(key === 'invoice') {
                setSelectednvoice(prev => prev.filter(item => Number(item.id) !== Number(id)));
            }
        }
    }

    
  return (
    <div className="p-3">
        {loading && <div > <Spinner/> </div>}
          {
            data?.length && data.map((sanctionOrder, index) => (
                <div className="border-prime-100 border-1 overflow-hidden rounded-3 mt-2" key={index}>
                    <FormControlLabel sx={{ backgroundColor: "#DFF0FF", width: "100%", left: "1%" }} className="position-relative"
                    control={
                        <>
                        {
                            approval && <Checkbox
                            checked={
                                selectedInvoice.filter(e => Number(e.sanction_order_id) === Number(sanctionOrder.sanction_order_id)).length ===
                                dataRef.current.filter(e => Number(e.sanction_order_id) === Number(sanctionOrder.sanction_order_id)).length
                            }
                            disabled={authData.user.user_type === 'l1'}
                            onChange={(e) => handleInvoiceSelect('sanctionOrder', sanctionOrder.sanction_order_id, e.target.checked)}
                        />
                        }
                        
                        <div className="d-flex justify-content-between align-items-center w-100 px-1 pe-2">
                            <div className="d-flex gap-3 align-items-center">
                            <div className="fs-12px d-flex align-items-center gap-1">
                                Sanction No: <span className="fs-14px fw-500">{sanctionOrder.sanction_order_no}</span>
                            </div>
                            <div className="fs-12px d-flex align-items-center gap-1">
                                Sanction Date:{" "}
                                <span className="fs-14px fw-500">{moment(sanctionOrder.sanction_order_date, 'YYYY-MM-DD').format('DD-MM-YYYY')}</span>
                            </div>
                            </div>
    
                            <div className="fs-12px d-flex align-items-center gap-1">
                            Total Amount: <span className="fs-14px fw-500">{sanctionOrder.sanction_amount}</span>
                            </div>
                        </div>
                        </>
                    }
                    />
                    {
                        sanctionOrder?.vouchers.map((voucher, voucherIndex) => (
                            <div style={{ display: "flex", flexDirection: "column", backgroundColor: "#FFF"}} className="px-3" key={voucherIndex}>
                                <div className="row position-relative p-2">
                                    <div className="m-0 p-0 d-flex align-items-center col-3">
                                        {
                                            approval && 
                                            <FormControlLabel control={
                                            <Checkbox 
                                                checked={
                                                    selectedInvoice.filter(e => Number(e.voucher_id) === Number(voucher.voucher_id)).length ===
                                                    dataRef.current.filter(e => Number(e.voucher_id) === Number(voucher.voucher_id)).length
                                                }
                                                disabled={authData.user.user_type === 'l1'}
                                                onChange={(e) => handleInvoiceSelect('voucher', voucher.voucher_id, e.target.checked)}
                                            />
                                            } className="p-0 m-0"/>
                                        }
                                        <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
                                            Voucher No: <span className="fs-14px fw-500">{voucher.voucher_no}</span>
                                        </div>
                                    </div>
    
                                    <div className="m-0 p-0 d-flex align-items-center col-3">
                                        <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
                                            Voucher Date: <span className="fs-14px fw-500">{moment(voucher.voucher_date, 'YYYY-MM-DD').format('DD-MM-YYYY')}</span>
                                        </div>
                                    </div>
    
                                    <div className="m-0 p-0 d-flex align-items-center col-3">
                                        <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
                                            Voucher Amount:
                                            <span className="fs-14px fw-500">{voucher.voucher_amount}</span>
                                        </div>
                                    </div>
    
                                    <div className="m-0 p-0 d-flex align-items-center justify-content-end col-3">
                                        <div className="fs-12px d-flex align-items-center text-link gap-1 p-0 m-0 pe-1">
                                            {activeKeys.includes(voucher.voucher_id) ? (
                                            <i
                                                className="icon-remove_circle fs-16px text-primary-50 cursor-pointer"
                                                onClick={() => handleInvoiceAccordian(voucher.voucher_id)}
                                            ></i>
                                            ) : (
                                            <i
                                                className="icon-add_circle fs-16px text-primary-50 cursor-pointer"
                                                onClick={() => handleInvoiceAccordian(voucher.voucher_id)}
                                            ></i>
                                            )}
                                        </div>
                                    </div>
                                    {
                                        activeKeys.includes(voucher.voucher_id) && voucher.invoices.map((invoice, invoiceIndex) => (
                                            <div className="m-0 p-0 px-2 mt-2" key={invoiceIndex}>
                                                <div className="m-0 p-0 d-flex flex-column gap-1">
                                                    <div className="row bg-success-20">
                                                        <div className="col-6 d-flex align-items-center">
                                                            {
                                                                (invoice.approval_status !== "2" && invoice.l3_approval_status !== "2") && <Checkbox
                                                                           checked={
                                                                                selectedInvoice.filter(e => Number(e.id) === Number(invoice.id)).length ===
                                                                                dataRef.current.filter(e => Number(e.id) === Number(invoice.id)).length
                                                                            }
                                                                            disabled={authData.user.user_type === 'l1'}
                                                                            onChange={(e) => handleInvoiceSelect('invoice', invoice.id, e.target.checked)}
                                                                        />
                                                            }
                                                            <div className="m-0 p-0 d-flex flex-column">
                                                            <span className="fw-500 fs-14px">
                                                                {invoice.company_name}
                                                            </span>
                                                            <span className=" text-black-60 fs-12px d-flex gap-2 align-items-center">
                                                                <span>Invoice No: {invoice.invoice_no}</span>
                                                                <span>Invoice Date: {moment(invoice.invoice_date, 'YYYY-MM-DD').format('DD-MM-YYYY')}</span>
                                                                <span className="fw-600 text-success-100">
                                                                {invoice.payment_type === '1' ? 'FULL PAYMENT' : 'PART PAYMENT'}
                                                                </span>
                                                            </span>
                                                            </div>
                                                        </div>
                                                        <div className="col-6 m-0 p-0">
                                                            <div className="row m-0 p-0 ">
                                                            <div className="col-2 m-0 p-0 d-flex flex-column justify-content-center">
                                                                <span className="fs-12px">Sanction</span>
                                                                <span className="fs-14px fw-500">{invoice.sanction_amount}</span>
                                                            </div>
                                                            <div className="col-2 m-0 p-0 d-flex flex-column justify-content-center">
                                                                <span className="fs-12px">Invoice</span>
                                                                <span className="fs-14px fw-500">{invoice.invoice_value}</span>
                                                            </div>
                                                            <div className="col-3 m-0 p-0 d-flex flex-column justify-content-center">
                                                                <span className="fs-12px">Payment Amount</span>
                                                                <span className="fs-14px fw-500">{invoice.payable_amount}</span>
                                                            </div>
                                                            <div className="col-5 m-0 p-0 d-flex align-items-center">
                                                                <div className="d-flex justify-content-between align-items-center ">
                                                                    <div className="d-flex align-items-center gap-2">
    
                                                                        <span className={`rounded-2 ${(invoice.approval_status === '1') ? 'bg-success-20' : (invoice.approval_status === '2') ? 'bg-danger-20' : 'bg-warning-20'} d-flex align-items-center px-2 gap-1`}
                                                                        >
                                                                            <span className="fs-12px text-black-60">L2</span>
                                                                            <span><i className={`${(invoice.approval_status === '1') ? 'icon-verified text-success-100' : (invoice.approval_status === '2') ? 'icon-warning_amber text-danger-100' : 'icon-warning_amber text-warning-100'}`} style={{ height: "14px", width: "14px" }}></i></span>
                                                                        </span>
    
                                                                        <span
                                                                        className={`${(invoice.l3_approval_status === '1') ? 'bg-success-20' : (invoice.l3_approval_status === '2') ? 'bg-danger-20' : 'bg-warning-20'} rounded-2 d-flex align-items-center px-2 gap-1`}
                                                                        >
                                                                            <span className="fs-12px text-black-60">L3</span>
                                                                            <span><i className={`${(invoice.l3_approval_status === '1') ? 'icon-verified text-success-100' : (invoice.l3_approval_status === '2') ? 'icon-warning_amber text-danger-100' : 'icon-warning_amber text-warning-100'}`} style={{ height: "14px", width: "14px" }}></i></span>
                                                                        </span>
    
                                                                        <span>
                                                                            <div className="d-flex gap-3 align-items-center">
                                                                                <i className="icon-remove_red_eye text-info-100"
                                                                                onClick={() => showInvoiceDetails(invoice)}
                                                                                ></i>
                                                                                {
                                                                                    showDeleteButton(authData.user.user_type, invoice.approval_status, invoice.l3_approval_status) && <i onClick={() => navigate(`/edit-invoice/${invoice.id}`)} className="icon-edit text-success-100"></i>
                                                                                }
                                                                                {
                                                                                    (showDeleteButton(authData.user.user_type, invoice.approval_status, invoice.l3_approval_status) && Number(invoice.invoice_count) === 1) && <i onClick={() => deleteInvoice(invoice.id)} className="icon-delete_outline text-danger-100"></i>
                                                                                }
                                                                            </div>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                    
                                </div>
    
                                {/* <div className="row px-2">
                                    <div className="m-0 p-0 d-flex align-items-center col-3">
                                        {
                                            approval && <FormControlLabel
                                            control={<Checkbox checked={checked[1]} onChange={handleChange3} />}
                                            className="p-0 m-0"
                                            />
                                        }
                                        <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
                                            Voucher No: <span className="fs-14px fw-500">1654321</span>
                                        </div>
                                    </div>
    
                                    <div className="m-0 p-0 d-flex align-items-center col-3">
                                        <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
                                            Voucher Date: <span className="fs-14px fw-500">1654321</span>
                                        </div>
                                    </div>
    
                                    <div className="m-0 p-0 d-flex align-items-center col-3">
                                        <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
                                            Voucher Amount:{" "}
                                            <span className="fs-14px fw-500">2,000,000,000.00</span>
                                        </div>
                                    </div>
    
                                    <div className="m-0 p-0 d-flex align-items-center justify-content-end col-3">
                                        <div className="fs-12px d-flex align-items-center text-link gap-1 p-0 m-0 pe-1" style={{ textDecoration: "underline" }}>
                                            View Invoice
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        ))
                    }
                </div>
            ))
          }
    
          
    
          {/* ===============================second card============================ */}
    
          {/* <div className="border-prime-100 border-1 overflow-hidden rounded-3 mt-3">
            <FormControlLabel
              // label="Parent"
              sx={{ backgroundColor: "#28326F", width: "100%", left: "1%" }}
              className="position-relative text-white"
              control={
                <>
                  <Checkbox
                    checked={checked[0] && checked[1]}
                    indeterminate={checked[0] !== checked[1]}
                    onChange={handleChange1}
                  />
                  <div className="d-flex justify-content-between align-items-center w-100 px-1 pe-2">
                    <div className="d-flex gap-3 align-items-center">
                      <div className="fs-12px d-flex align-items-center gap-1">
                        Sanction No: <span className="fs-14px fw-500">1654321</span>
                      </div>
                      <div className="fs-12px d-flex align-items-center gap-1">
                        Sanction Date:{" "}
                        <span className="fs-14px fw-500">25/12/5243</span>
                      </div>
                    </div>
    
                    <div className="fs-12px d-flex align-items-center gap-1">
                      Total Amount: <span className="fs-14px fw-500">255612</span>
                    </div>
                  </div>
                </>
              }
            />
            {children}
          </div> */}
          {/* ===============================third card============================ */}
    
          {/* <div className="border-prime-100 border-1 overflow-hidden rounded-3 mt-3">
            <FormControlLabel
              // label="Parent"
              sx={{ backgroundColor: "#2490EA", width: "100%", left: "1%" }}
              className="position-relative text-white"
              control={
                <>
                  <Checkbox
                    checked={checked[0] && checked[1]}
                    indeterminate={checked[0] !== checked[1]}
                    onChange={handleChange1}
                  />
                  <div className="d-flex justify-content-between align-items-center w-100 px-1 pe-2">
                    <div className="d-flex gap-3 align-items-center">
                      <div className="fs-16px d-flex align-items-center gap-1 fw-600">
                        A Uttarakhand Purv Sainik Kalyan Nigam ltd.
                      </div>
                    </div>
                    <div className="d-flex  gap-2">
                      <div className="fs-12px d-flex align-items-center gap-1">
                        sensation: <span className="fs-14px fw-500">255612</span>
                      </div>
                      <div className="fs-12px d-flex align-items-center gap-1">
                        Invoice Amount:{" "}
                        <span className="fs-14px fw-500">255612</span>
                      </div>
                      <div className="fs-12px d-flex align-items-center gap-1">
                        Payment: <span className="fs-14px fw-500">255612</span>
                      </div>
                    </div>
                  </div>
                </>
              }
            />
            {children3}
          </div> */}
          
    
          {/* ===========================overlay========================= */}
    
          <InvoiceOverlay
            overlay={overlay}
            setOverlay={setOverlay}
            invoiceDetails={invoiceDetailsRef.current}
          />
    </div>
  )
}

export default InvoiceList